// import { gsap } from 'gsap';
// import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
// gsap.registerPlugin(ScrollToPlugin);


export default class{

    constructor( options ) {
        this.defaults = {
        	el: false,
            main: undefined
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'module-submenu-barba-view';
		this.el 			= 	this.options.el;
		this.main			=   this.options.main;

		this.init( true );
    }

    init( b ){
        if ( b ){
            this.as = this.el.querySelectorAll( 'a.barba-view' );
            /*
            // debug
            this.as.forEach( ( a, i ) => {
                a.classList.add( 'no-barba' );
            });
            */
        }
        if ( this.as.length > 0 ){
    	    this.addEvents( b );
        }
	}

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
			this.el.addEventListener( 'click', this.onClick );
            //this.el.addEventListener( 'mouseenter', this.onMouseEnter );
            //this.el.addEventListener( 'mouseleave', this.onMouseLeave );
		}
		else{
			this.el.removeEventListener( 'click', this.onClick );
		}
	}

	onClick = ( e ) => {
		if ( e.target.matches( 'a' ) ){
            if ( this.as.length > 1 ){
                this.as.forEach( ( a, i ) => {
                    if ( a.getAttribute( 'href' ) === e.target.getAttribute( 'href' ) ){
                        a.parentNode.classList.add( 'current-menu-item' );
                    }
                    else{
                        a.parentNode.classList.remove( 'current-menu-item' );
                    }
                } )
            }
        }
 	}

    /*
    onMouseEnter = ( e ) => {
		if ( e.target.matches( 'a' ) ){
            if ( this.as.length > 1 ){
                this.as.forEach( ( a, i ) => {
                    if ( a.parentNode.classList.contains( 'current-menu-item' ) ){
                        console.log( 'sssss' );
                        a.style.opacity = 0.5;
                    }
               } )
            }
        }
    }

    onMouseLeave = ( e ) => {
		if ( e.target.matches( 'a' ) ){
            if ( this.as.length > 1 ){
                this.as.forEach( ( a, i ) => {
                    a.style.opacity = 1;
               } )
            }
        }
    }
    */

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
    	this.init( false );
    }

}
